require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./executive-master-of-business-administration-emba-2-4-0-0.json") })
        }
      }, "path---executive-master-of-business-administration-emba-2-4-0-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---executive-master-of-business-administration-emba-2-4-0-0!./.cache/json/executive-master-of-business-administration-emba-2-4-0-0.json
// module id = 428
// module chunks = 231608221292675